import Vue from 'vue';

import { BootstrapVue, IconsPlugin } from 'bootstrap-vue';

import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap-vue/dist/bootstrap-vue.css';

import './assets/css/main.css';
import './assets/css/switch.css';

import lodash from 'lodash';

import VueLodash from 'vue-lodash';

import { library } from '@fortawesome/fontawesome-svg-core';
import {
    faTrash, faSave, faEdit, faPlus, faUsers, faCode,
} from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';

import modal from 'vue-js-modal';
import axios from 'axios';
import VueAxios from 'vue-axios';
import VueToastr from 'vue-toastr';
import PulseLoader from 'vue-spinner/src/PulseLoader.vue';

// eslint-disable-next-line no-unused-vars
import ChartJSPluginDatalabels from 'chartjs-plugin-datalabels';

import VueQuillEditor from 'vue-quill-editor';
import Clipboard from 'v-clipboard';
import App from './App.vue';

import router from './router';
import store from './store';

import Admin from './layouts/Admin.vue';
import Empty from './layouts/Empty.vue';
import Error from './layouts/Error.vue';

import 'quill/dist/quill.core.css';
import 'quill/dist/quill.snow.css';

Vue.use(Clipboard);
Vue.use(VueQuillEditor);

Vue.component('admin-layout', Admin);
Vue.component('empty-layout', Empty);
Vue.component('error-layout', Error);

library.add(faTrash);
library.add(faSave);
library.add(faPlus);
library.add(faEdit);
library.add(faUsers);
library.add(faCode);

Vue.component('font-awesome-icon', FontAwesomeIcon);
Vue.component('pulse-loader', PulseLoader);

Vue.use(VueToastr, {
    defaultPosition: 'toast-bottom-right',
});

Vue.use(BootstrapVue);
Vue.use(IconsPlugin);
Vue.use(modal);
Vue.use(VueAxios, axios);

Vue.use(require('vue-moment'));

Vue.use(VueLodash, { lodash });
Vue.config.productionTip = false;

const accessToken = JSON.parse(localStorage.getItem('accessToken'));

if (accessToken) {
    axios.defaults.headers.common = {
        Authorization: `Bearer ${accessToken.token}`,
    };

    store.state.accessToken = accessToken;
}

new Vue({
    router,
    store,
    render: (h) => h(App),
}).$mount('#app');

window._ = require('lodash');
